import { render, staticRenderFns } from "./WeightManagement.vue?vue&type=template&id=21c85050&scoped=true&"
import script from "./WeightManagement.vue?vue&type=script&lang=ts&"
export * from "./WeightManagement.vue?vue&type=script&lang=ts&"
import style0 from "./WeightManagement.vue?vue&type=style&index=0&id=21c85050&prod&lang=scss&"
import style1 from "./WeightManagement.vue?vue&type=style&index=1&id=21c85050&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c85050",
  null
  
)

export default component.exports